import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from "../../hooks/hook";
const ShowNameChat = () => {
    const name = useAppSelector(state => {
        var _a;
        if (state.app.selectedChannel)
            return state.app.selectedChannel.displayName;
        return ((_a = state.app.selectedChat) === null || _a === void 0 ? void 0 : _a.nameWasGiven) || state.app.selectedChat.displayName;
    });
    return (_jsx("span", { children: name }));
};
export default ShowNameChat;
